/**
 * Typography Tokens
 * 
 * Font families, sizes, weights, line heights, and letter spacing for consistent text styling.
 * All typography tokens use the "Outfit" font family.
 * 
 * Based on Figma variable collection: Typography
 */

export const fontFamily = {
  primary: 'Outfit',
} as const;

export const fontWeights = {
  regular: 400,
  medium: 500,
} as const;

export const typographyTokens = {
  'Body/Small': {
    family: fontFamily.primary,
    style: 'Regular',
    size: 12,
    weight: fontWeights.regular,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
  'Body/Medium': {
    family: fontFamily.primary,
    style: 'Regular',
    size: 14,
    weight: fontWeights.regular,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
  'Body/Large': {
    family: fontFamily.primary,
    style: 'Regular',
    size: 16,
    weight: fontWeights.regular,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
  'Headings/H3': {
    family: fontFamily.primary,
    style: 'Medium',
    size: 18,
    weight: fontWeights.medium,
    lineHeight: 1.2,
    letterSpacing: 0,
  },
  'Links/Btn Text': {
    family: fontFamily.primary,
    style: 'Medium',
    size: 14,
    weight: fontWeights.medium,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
} as const;

// Type exports for TypeScript support
export type TypographyToken = keyof typeof typographyTokens;
export type TypographyConfig = typeof typographyTokens[TypographyToken];

// Helper function to get typography CSS properties
export const getTypography = (token: TypographyToken) => {
  const config = typographyTokens[token];
  return {
    fontFamily: config.family,
    fontSize: `${config.size}px`,
    fontWeight: config.weight,
    lineHeight: config.lineHeight,
    letterSpacing: `${config.letterSpacing}px`,
  };
};

// Helper function to get typography as CSS string
export const getTypographyCSS = (token: TypographyToken): string => {
  const config = typographyTokens[token];
  return `font-family: ${config.family}; font-size: ${config.size}px; font-weight: ${config.weight}; line-height: ${config.lineHeight}; letter-spacing: ${config.letterSpacing}px;`;
};

// Helper function to get font size in pixels
export const getFontSize = (token: TypographyToken): string => {
  return `${typographyTokens[token].size}px`;
};

// Helper function to get font size as number
export const getFontSizeNumber = (token: TypographyToken): number => {
  return typographyTokens[token].size;
};


